import * as d3Fetch from 'd3-fetch'

const stringFields = [
  'country',
  'country_iso',
  'description_english',
  'date_of_announcement',
  'top_leaders',
  'iso',
  'country_eng',
  'region_eng',
  'unique_iso',
  'unique_id'
]

const stringify = d => {
  for (var i in d) {
    if (!stringFields.includes(i)) {
      d[i] = +d[i]
    }
  }
  return d
}

// Helper function to parseData that adds region and income level info
const addReferenceData = (trip, countriesData) => {
  let region = []
  let incomeLevels = []
  let total = 0

  // Format country string into an array
  for (const c of trip.country_iso.split(", ")) {
    // Linking the countries of the trip to their reference data via unique id (iso + year)
    const country = countriesData.find(d => d.unique_iso === c + trip.year)

    if (country) { 
      total += 1
    }

    if (country && !region.includes(country.region_eng)) {
      region.push(country.region_eng)
    }
    
    if (country && !incomeLevels.includes(country.income_level)) {
      incomeLevels.push(country.income_level)
    }
    
  }

  total = total | 1

  trip['total'] = total

  if (trip['virtual'] === 1) {
    trip['region'] = 'Virtual'
  } else if (region.length > 1) {
    trip['region'] = 'Multi'
  } else {
    trip['region'] = region[0]
  }

  if (trip['virtual'] === 1) {
    trip['income_level'] = 'Virtual'
  } else if (incomeLevels.length > 1) {
    trip['income_level'] = 'Multi'
  } else {
    trip['income_level'] = incomeLevels[0]
  }
}

function parseData({ src }) {
  const tripsPromise = d3Fetch.csv(src.trips, stringify)
  const refPromise = d3Fetch.csv(src.ref, stringify)
  
  let data = Promise.all([tripsPromise, refPromise]).then(res => {
    const [tripsData, countriesData] = res
    
    let dataset = {
      tripsData: [],
      years: [],
    }

    for (const trip of tripsData) {
 
      if (!dataset.tripsData.find(d => d.leader === trip.top_leaders)) {
       
        addReferenceData(trip, countriesData)

        dataset.tripsData.push({
          leader: trip.top_leaders,
          children: [trip],
        })

        if (dataset.years.indexOf(trip.year) === -1) {
          dataset.years.push(
            trip.year
          )
        }


      } else {
        addReferenceData(trip, countriesData)

        dataset.tripsData.find(d => d.leader === trip.top_leaders).children.push(trip)

        if (dataset.years.indexOf(trip.year) === -1) {
          dataset.years.push(
            trip.year
          )
        }
      }

    }

    console.log({...dataset, tripsData: dataset.tripsData.slice(0,5)})

    return {...dataset, tripsData: dataset.tripsData.slice(0,5)}
  })
  
  return data
}

export default parseData